export const zoneMeaningMap: Record<string, string> = {
  'ZONE 1': 'Within City',
  'ZONE 2': 'Within State',
  'ZONE 3': 'Metro to Metro',
  'ZONE 4': 'Rest of India',
  'ZONE 5': 'Special Location',
  'ZONE A': 'Within City',
  'ZONE B': 'Within State',
  'ZONE C': 'Metro to Metro',
  'ZONE D': 'Rest of India',
  'ZONE E': 'Special Location',
  '1': 'Within City',
  '2': 'Within State',
  '3': 'Metro to Metro',
  '4': 'Rest of India',
  '5': 'Special Location',
};

